import React from 'react';

import { Form, Row, Col, Select, Checkbox } from 'antd';

import { WrapperSelect } from 'common/components';

import DownloadFolderProductMapping from './DownloadFolderProductMapping';
import DownloadFolderHierarchySetting from './DownloadFolderHierarchySetting';

import { useFormatMessage } from 'hooks';

import { PRODUCTS_DATA_FORMAT } from 'static/Constants';
import { dropdownConfigs } from '../../constants';

import Messages from 'i18n/messages/folder';

const formProductLayout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const DownloadFolderProductSetting = (props) => {
  const form = Form.useFormInstance();
  const selectedMapping = Form.useWatch('selectedMapping', form);

  const messages = useFormatMessage(Messages);

  const dataFormat = selectedMapping?.formatTypes
    ? selectedMapping?.formatTypes?.slice().sort()
    : PRODUCTS_DATA_FORMAT.map((formatType) => formatType.toUpperCase());

  return (
    <>
      <DownloadFolderProductMapping />

      <Row gutter={[16, 4]}>
        <Col span={12}>
          <Form.Item
            {...formProductLayout}
            name='productDataFormat'
            label='Data Format'
          >
            <WrapperSelect
              getPopupContainer={(trigger) => trigger.parentElement}
              allowClear={false}
            >
              {dataFormat.map((type) => (
                <Select.Option key={type} value={type}>
                  {type}
                </Select.Option>
              ))}
            </WrapperSelect>
          </Form.Item>
        </Col>

        {dropdownConfigs().map(({ name, options, renderLabel }) => (
          <Col span={12} key={name}>
            <Form.Item
              {...formProductLayout}
              name={name}
              label={messages[name]}
            >
              <WrapperSelect
                getPopupContainer={(trigger) => trigger.parentElement}
              >
                {options.map((option) => {
                  const label = renderLabel ? renderLabel(option) : option;

                  return (
                    <Select.Option key={option} value={option}>
                      <span>{label}</span>
                    </Select.Option>
                  );
                })}
              </WrapperSelect>
            </Form.Item>
          </Col>
        ))}
        <Col span={12}>
          <Form.Item
            {...formProductLayout}
            name='productImageSquare'
            label={'Square Image'}
            valuePropName='checked'
          >
            <Checkbox />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            {...formProductLayout}
            name='includeExtension'
            label='Include Extension'
            valuePropName='checked'
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>

      <DownloadFolderHierarchySetting />
    </>
  );
};

export default DownloadFolderProductSetting;
